import { render, staticRenderFns } from "./channelPage.vue?vue&type=template&id=057a5fc2&scoped=true&"
import script from "./channelPage.vue?vue&type=script&lang=js&"
export * from "./channelPage.vue?vue&type=script&lang=js&"
import style0 from "./channelPage.vue?vue&type=style&index=0&id=057a5fc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057a5fc2",
  null
  
)

export default component.exports